import style from "./index.css";

export default props => {
  return (
    <div className="faq-collapse-trigger">
      <p>{props.title}</p>
      <span>
        <i className="fas fa-chevron-down"></i>
      </span>
      <style jsx>{style}</style>
    </div>
  );
};
